<template>
    <app-settings-group ref="group" v-model="model" :items="items" title="theme" />
</template>

<script setup lang="ts">
// Components
import AppSettingsGroup from './Group.vue'

// Utilities
import { computed, ref } from 'vue'

const { appThemeCookie } = useACookie();
const group = ref<InstanceType<typeof AppSettingsGroup>>()

const items = [
    {
        text: 'light',
        icon: '$mdiWhiteBalanceSunny',
    },
    {
        text: 'dark',
        icon: '$mdiWeatherNight',
    },
    {
        text: 'system',
        icon: '$mdiDesktopTowerMonitor',
    }
]

const model = computed({
    get() {
        return appThemeCookie.value
    },
    set(val: string[]) {
        if (val) {
            appThemeCookie.value = val
        }
    },
})
</script>